// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Content from 'components/Content';
import Section from 'components/Section';
import { teal } from 'api';

function OrganisationPage() {
    const { organisationId } = useParams();
    const organisation = useSelector(state => state.auth.user.organisations.find(org => org.organisationId === organisationId));
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    const getUserName = (user) => {
        if (!user) return '-';
        if (user.name) return user.name;
        const firstName = (user.firstName || '').trim();
        const lastName = (user.lastName || '').trim();
        const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
        return fullName || '-';
    };

    const getUserId = (user) => {
        if (!user) return '-';
        return user.id || user.userId || '-';
    };

    useEffect(() => {
        async function fetchUsers() {
            try {
                const fetchedUsers = await teal.getUsersInOrganisation(organisationId);
                setUsers(fetchedUsers);
            } catch (error) {
                console.error('Failed to fetch organisation users:', error);
            } finally {
                setLoading(false);
            }
        }

        fetchUsers();
    }, [organisationId]);

    return (
        <Content>
            <Section title={ 'Organisation' } >
                <Table style={{ marginTop: '20px' }}>
                    <TableBody>
                        <TableRow>
                            <TableCell>Virksomhedsnavn:</TableCell>
                            <TableCell>Virksomhedens ID:</TableCell>
                            <TableCell>CVR-nummer:</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>{ organisation.name }</TableCell>
                            <TableCell><span style={{ fontFamily: 'Courier, monospace' }} >{ organisation.organisationId }</span></TableCell>
                            <TableCell>{ organisation.vatin }</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Section>

            <Section title={ 'Brugere' } >
                { loading ? (
                    <p>Indlæser brugere...</p>
                ) : (
                    <Table style={{ marginTop: '20px' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Navn</TableCell>
                                <TableCell>Id</TableCell>
                                <TableCell>Email</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { users.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={ 3 }>Kunne ikke indhente brugere</TableCell>
                                </TableRow>
                            ) : (
                                users.map(user => (
                                    <TableRow key={ user.id || user.userId || user.email }>
                                        <TableCell>{ getUserName(user) }</TableCell>
                                        <TableCell><span style={{ fontFamily: 'Courier, monospace' }} >{ getUserId(user) }</span></TableCell>
                                        <TableCell>{ user.email }</TableCell>

                                    </TableRow>
                                ))
                            ) }
                        </TableBody>
                    </Table>
                ) }
            </Section>
        </Content>
    );
}

export default OrganisationPage;
